/**
 * Store-wide page_view (GA4 + labeled Ads conversion) + PDP view_item / Dynamic Remarketing.
 * Reads window.__ILD_ECOM_VIEW on product pages.
 */
(function () {
  'use strict';

  var GT_SEND_TO = 'GT-T5P4FHD';
  var GA4_ID = 'G-XE6CZ5DL31';
  /* Google Shopping App Page View (2) — from Google Ads API tag snippet */
  var AW_PAGE_VIEW_CONVERSION = 'AW-870900097/1xEaCO6467wcEIHDo58D';

  function itemPayload(data) {
    var id = String(data.item_id || '');
    var name = data.item_name || '';
    var price = parseFloat(data.value);
    if (isNaN(price)) price = 0;
    return {
      item_id: id,
      id: id,
      item_name: name,
      price: price,
      quantity: 1,
      google_business_vertical: 'retail',
    };
  }

  function firePageViewOnce() {
    if (window.__ildThemePageViewFired) return;
    window.__ildThemePageViewFired = true;
    if (typeof gtag !== 'function') return;
    gtag('event', 'page_view', {
      send_to: GA4_ID,
      page_location: window.location.href,
      page_title: document.title,
    });
    gtag('event', 'conversion', {
      send_to: AW_PAGE_VIEW_CONVERSION,
      value: 1.0,
      currency:
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
    });
  }

  function fireViewItemRemarketing(data) {
    if (typeof gtag !== 'function') return false;
    if (!data || !data.item_id) return false;
    if (window.__ildViewItemRemarketingFired) return true;

    var currency =
      data.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    var item = itemPayload(data);
    var value = item.price;

    gtag('event', 'view_item', {
      send_to: GT_SEND_TO,
      currency: currency,
      value: value,
      items: [item],
    });

    // Also send view_item to GA4 (restores GA4 product-view).
    gtag('event', 'view_item', {
      send_to: GA4_ID,
      currency: currency,
      value: value,
      items: [item],
    });

    gtag('event', 'Dynamic Remarketing', {
      send_to: GT_SEND_TO,
      value: value,
      currency: currency,
      items: [item],
    });

    window.__ildViewItemRemarketingFired = true;
    return true;
  }

  function tryFireViewItem() {
    if (window.__ildViewItemRemarketingFired) return;
    var data = window.__ILD_ECOM_VIEW;
    if (!data || !data.item_id) return;
    fireViewItemRemarketing(data);
  }

  window.__ildFirePageViewOnce = firePageViewOnce;
  window.__ildFireViewItemRemarketing = fireViewItemRemarketing;

  function schedule() {
    firePageViewOnce();
    tryFireViewItem();
    if (window.__ildViewItemRemarketingFired) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      tryFireViewItem();
      if (window.__ildViewItemRemarketingFired || attempts >= 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
